import { i18n } from '@/plugins/vue-i18n';
import { entityIcon as entityIconUtil } from '@/modules/entity/utils';

export function entityIcon(type) {
  return entityIconUtil(type);
}

export function extraChips(extra) {
  if (!extra) {
    return [];
  }
  // eslint-disable-next-line
  return extra.map(b => tooltip(chip(i18n.te(`message.metadata.${b}`) ? i18n.t(`message.metadata.${b}`) : b), i18n.t(`message.metadata.${b}`)))
}

export function chip(value, color, textColor, image, action = null) {
  return {
    value,
    color,
    textColor,
    image,
    action,
  };
}

export function tooltip(ch, value) {
  return {
    ...ch,
    tooltip: value,
  };
}

export function metadata(text, value, link = false) {
  return { text, value, link };
}

export const Actions = {
  ADD_BAG: 'bag',
  METADATA: 'metadata',
  LINK: 'link',
};

export function flag(entity) {
  if (entity.scheduled) {
    return tooltip({ color: '#ffa01c' }, 'Programado');
  }
  if (entity.published) {
    return tooltip({ color: '#4ed19c' }, 'Publicado');
  }
  return null;
}
